
import { showErrorToasts } from "../../services/helpers/Helper";
import { ERROR_TYPE } from "../constants";

export const setError = (message) =>
   async (dispatch, getState) => {
      const { global } = getState();
      if (!global.loginExpired) {
         showErrorToasts(message);
      }
      dispatch({
         type: ERROR_TYPE.SET,
         payload: {
            open: true,
            message: message
         }
      });
   };

export const clearError = () =>
   async (dispatch) => {
      dispatch({
         type: ERROR_TYPE.CLEAR,
         payload: {
            open: false,
            message: ""
         }
      });
   };